module.exports = __webpack_public_path__ + "static/chorus-2-326b554fcf90143227a6bf3bae5cc8fd.jpg";